import React from "react";
import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import AdminsListItem from "./adminsListItem";
import PropTypes from "prop-types";

const AdminList = ({ handleEditItem, handleDeleteItem, admins }) =>
  admins.length === 0 ? (
    <Paper className="p-4 text-center">لا يوجد مديرون</Paper>
  ) : (
    <TableContainer component={Paper} className="table-responsive">
      <Table className="table table-fixed">
        <TableHead>
          <TableRow className="admins__theader">
            <TableCell align="center">#</TableCell>
            <TableCell align="center">الاسم</TableCell>
            <TableCell align="center">البريد الإلكتروني</TableCell>
            <TableCell align="center">الحالة</TableCell>
            <TableCell align="center">افعال</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {admins.map((item, index) => (
            <AdminsListItem
              {...item}
              index={index + 1}
              handleEditItem={() => handleEditItem(item.id)}
              handleDeleteItem={() => handleDeleteItem(item.id)}
              key={item.id}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
AdminList.propTypes = {
  handleDeleteItem: PropTypes.func.isRequired,
  handleEditItem: PropTypes.func.isRequired,
  admins: PropTypes.array.isRequired,
};

export default AdminList;
